import {
	QueryFunctionContext,
	useInfiniteQuery,
	useQueryClient,
} from 'react-query';
import {
	getDisplayAdRequests,
	invoiceDisplayAd,
	cancelDisplayAd,
	updateDisplayAd,
} from '../../../services/ad.service';

const getDisplayAdRequestsQuery = () => {
	return async (context: QueryFunctionContext) => {
		return getDisplayAdRequests({
			skip: context.pageParam || 0,
			limit: 1000,
		});
	};
};

const useDisplayAdRequests = () => {
	const queryClient = useQueryClient();
	const {
		data,
		isFetching,
		refetch,
		remove,
		isFetched,
		hasNextPage,
		isFetchingNextPage,
		fetchNextPage,
	} = useInfiniteQuery<{
		data: any[];
		metaData: { skip: number; totalRecords: number };
	}>(['displayAdRequests'], getDisplayAdRequestsQuery(), {
		getNextPageParam: (lastGroup) => lastGroup?.metaData?.skip || undefined,
		refetchOnWindowFocus: false,
	});

	const invoice = async (id?: number) => {
		if (!id) return;
		const res = await invoiceDisplayAd(id);
		const newPages = data?.pages?.map((page) => {
			const newPage = page.data.map((row: any) => {
				if (row.id === res.id) {
					return res;
				}
				return row;
			});
			return { data: newPage, metaData: page.metaData };
		});
		queryClient.setQueryData('displayAdRequests', {
			...data,
			pages: newPages,
		});
	};

	const cancel = async (id?: number) => {
		if (!id) return;
		const res = await cancelDisplayAd(id);
		const newPages = data?.pages?.map((page) => {
			const newPage = page.data.map((row: any) => {
				if (row.id === res?.request?.id) {
					return res.request;
				}
				return row;
			});
			return { data: newPage, metaData: page.metaData };
		});
		queryClient.setQueryData('displayAdRequests', {
			...data,
			pages: newPages,
		});
	};

	const update = async (updatedFields: any) => {
		const res = await updateDisplayAd(updatedFields.id, updatedFields);
		const newPages = data?.pages?.map((page) => {
			const newPage = page.data.map((row: any) => {
				if (row.id === res?.request?.id) {
					return res.request;
				}
				return row;
			});
			return { data: newPage, metaData: page.metaData };
		});
		queryClient.setQueryData('displayAdRequests', {
			...data,
			pages: newPages,
		});
	};

	return {
		isFetching,
		data,
		refetch,
		remove,
		isFetched,
		isFetchingNextPage,
		hasNextPage,
		invoice,
		cancel,
		update,
		fetchNextPage,
	};
};

export default useDisplayAdRequests;
